// extracted by css-extract-rspack-plugin
export default {"cls1":"WorkMetadata-cls1_IAT","cls2":"WorkMetadata-cls2_1oY WorkMetadata-cls1_IAT"};